const MAP = [
  ["Aucun auto-clip de live", "ce.no_live"],
  ["Reconnexion au live", "ce.reconnecting"],
  ["Le live vient de démarrer", "ce.starting"],
  ["Un clip est déjà en cours", "ce.busy"],
  ["clips gratuits de la semaine", "ce.credits"],
  ["Clé CLIP-EX invalide", "ce.bad_key"],
];

export const clipErr = (msg, t) => {
  const hit = MAP.find(([s]) => (msg || "").includes(s));
  return hit ? t(hit[1]) : msg;
};
